module.exports = __webpack_public_path__ + "static/media/2.7a813615.jpg";